import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import {doSeamlessLogin} from '../../../../utils/utils';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {localUsersIcon} from "../../../../assets/images/headerIcons";
import BaseLocalUsers from "../../AbstractObjects/GatewayPlan/InnerPages/BaseLocalUsers";

const pageSchema = GatewayGetSchema.pages.localUsers;
const pageId = pageSchema.pageId;

function GatewayLocalUsers({
                                   gatewayObject,
                                   planObject,
                                   setGatewayData
                               }) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.localUsers.fieldId], planPage[pageSchema.localUsers.fieldId]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
            <LockToPlanContainer
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMP.GATEWAYS.INNER_MENU.LOCAL_USERS')}
                icon={localUsersIcon}
            >
                <BaseLocalUsers
                    pageData={currentPageData}
                    setObjectData={setGatewayData}
                    pageDisabled={lockedToPlan}
                />
            </LockToPlanContainer>
            <Indentation>
                <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.UsersView')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.LOCAL_USERS')}</SMCLink>
            </Indentation>
        </>
    );
}

export default GatewayLocalUsers;